<template>
    <form action="">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Login</p>
            </header>
            <section class="modal-card-body">
                <b-field label="Email">
                    <b-input
                        type="email"
                        name="email"
                        v-model="email"
                        placeholder="Your email"
                        required>
                    </b-input>
                </b-field>

                <b-field label="Password">
                    <b-input
                        type="password"
                        name="password"
                        v-model="password"
                        password-reveal
                        placeholder="Your password"
                        required>
                    </b-input>
                </b-field>

                <b-checkbox>Remember me</b-checkbox>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.close()">Close</button>
                <button class="button is-primary" @click.prevent="login()">Login</button>
            </footer>
        </div>
    </form>
</template>

<script>
    import { ToastProgrammatic as Toast } from 'buefy'

    export default {
        data() {
            return {
                email: '',
                password: ''
            }
        },
        methods: {
            danger() {
                Toast.open({
                    duration: 2000,
                    message: `Invalid email or password`,
                    type: 'is-danger'
                });
                this.password = "";
            },
            login() {
                const auth = firebase.auth();
                const promise = auth.signInWithEmailAndPassword(this.email, this.password);
                promise.then(e => {
                    Toast.open({
                        duration: 2000,
                        message: `You've logged in successfully`,
                        type: 'is-success'
                    });
                    this.$router.push('/admin');
                }).catch(e => Toast.open({
                    duration: 2000,
                    message: `Invalid email or password`,
                    type: 'is-danger'
                }));

            }
        }
    }
</script>

<style scoped>
    .modal-card {
        width: auto;
    },
    .control-label {
        color: #000000;
    }
</style>



// WEBPACK FOOTER //
// ModalForm.vue?31f79f24